import { Routes, Route, useLocation } from 'react-router-dom';
import PageTransition from './components/PageTransition/PageTransition';
import './App.css';
import Header from './components/Header/Header';
import VideoCarousel from "./components/VideoCarousel/VideoCarousel";
import AboutUs from './components/AboutUs/AboutUs';
import Services from './components/Services/Services';
import Technologies from './components/Technologies/Technologies';
import Footer from './components/Footer/Footer';
import VerticalScrollbar from './components/VerticalScrollbar/VerticalScrollbar';
import Careers from './components/Careers/Careers';

function HomePage() {
  return (
    <div className="app">
      <div className="header" id="header"><Header /></div>
      <div className="video-carousel" id="home"><VideoCarousel /></div>
      <div className="about-us" id="about"><AboutUs /></div>
      <div className="our-services" id="services"><Services /></div>
      <div className="our-works" id="technologies"><Technologies /></div>
      <div className="footer" id="footer"><Footer /></div>
      <VerticalScrollbar />
    </div>
  );
}

function App() {
  const location = useLocation();

  return (
    <Routes location={location} key={location.pathname}>
      <Route path="/" element={<HomePage />} />
      <Route path="/careers" element={
        <PageTransition>
          <Careers />
        </PageTransition>
      } />
    </Routes>
  );
}

export default App;